import { LiveDashboard } from '../../types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const liveDashboardsService = {
  /** Every cloud dashboard of the site, all product licences. */
  list: async (siteId: string): Promise<LiveDashboard[]> => {
    const response = await apiClient.get<LiveDashboard[]>(ENDPOINTS.liveDashboards.list(siteId))
    return response.data
  },
  /** The site's cloud dashboards for one product licence (same rule as dashboardsService.listByLicense). */
  listByLicense: async (siteId: string, licenseName: string): Promise<LiveDashboard[]> => {
    const dashboards = await liveDashboardsService.list(siteId)
    return dashboards.filter((dashboard) => dashboard.ProductLicense === licenseName)
  },
}
